<template>
  <el-dialog v-dialogDrag title="邀请好友" :visible.sync="show" width="620px" :before-close="close">
    <div class="container">
      <div class="left-box">
        <div class="search">
          <el-input placeholder="搜索好友" v-model="searchText" size="small">
            <i class="el-icon-search el-input__icon" slot="suffix"> </i>
          </el-input>
        </div>
        <virtual-scroller class="invite-scroll" :items="filteredFriends" :item-height="60" item-key="id">
          <template v-slot="{ item }">
            <friend-item @click.native="onSwitchCheck(item)" :menu="false" :friend="item">
              <el-checkbox :disabled="isMember(item.id)" @click.native.stop="" class="friend-checkbox"
                :value="isChecked(item.id)" @change="onSwitchCheck(item)"></el-checkbox>
            </friend-item>
          </template>
        </virtual-scroller>
      </div>
      <div class="arrow el-icon-d-arrow-right"></div>
      <div class="right-box">
        <div class="select-tip"> 已勾选{{ checkCount }}位好友</div>
        <el-scrollbar style="height:400px;">
          <div v-for="friend in checkedFriends" :key="friend.id">
            <friend-item :friend="friend" :active="false" @del="onRemoveFriend(friend)" :menu="false">
            </friend-item>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取 消</el-button>
      <el-button type="primary" @click="onOk()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import FriendItem from '../friend/FriendItem.vue';
import VirtualScroller from '../common/VirtualScroller.vue';

export default {
  name: "addGroupMember",
  components: {
    FriendItem,
    VirtualScroller
  },
  data() {
    return {
      show: false,
      searchText: "",
      checkedMap: {},
      memberIdMap: {}
    }
  },
  methods: {
    open() {
      this.show = true;
      this.searchText = "";
      this.checkedMap = {};
      const memberIdMap = {};
      (this.members || []).forEach((m) => {
        if (m && !m.quit && m.userId != null) {
          memberIdMap[m.userId] = true;
        }
      });
      this.memberIdMap = memberIdMap;
    },
    close() {
      this.show = false;
    },
    isMember(id) {
      return !!this.memberIdMap[id];
    },
    isChecked(id) {
      return !!this.checkedMap[id] || this.isMember(id);
    },
    onOk() {
      let inviteVO = {
        groupId: this.groupId,
        friendIds: Object.keys(this.checkedMap).filter((id) => this.checkedMap[id] && !this.memberIdMap[id]).map((id) => Number(id) || id)
      }
      if (inviteVO.friendIds.length > 0) {
        this.$http({
          url: "/group/invite",
          method: 'post',
          data: inviteVO
        }).then(() => {
          this.$message.success("邀请成功");
          this.$emit("reload");
          this.close()
        })
      }
    },
    onRemoveFriend(friend) {
      this.$set(this.checkedMap, friend.id, false);
    },
    onSwitchCheck(friend) {
      if (this.isMember(friend.id)) {
        return;
      }
      this.$set(this.checkedMap, friend.id, !this.checkedMap[friend.id]);
    }
  },
  props: {
    groupId: {
      type: Number
    },
    members: {
      type: Array
    }
  },
  computed: {
    filteredFriends() {
      if (!this.show) {
        return [];
      }
      this.$store.state.friendStore.friendsVersion;
      const keyword = this.searchText || '';
      const friends = this.$store.getters.friendList || [];
      const out = [];
      for (let i = 0; i < friends.length; i++) {
        const friend = friends[i];
        if (!friend || friend.deleted) {
          continue;
        }
        if (keyword && !(friend.showNickName || '').includes(keyword)) {
          continue;
        }
        out.push(friend);
      }
      return out;
    },
    checkedFriends() {
      return Object.keys(this.checkedMap)
        .filter((id) => this.checkedMap[id] && !this.memberIdMap[id])
        .map((id) => this.$store.getters.findFriend(id))
        .filter(Boolean);
    },
    checkCount() {
      return this.checkedFriends.length;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  .left-box {
    flex: 1;
    overflow: hidden;
    border: var(--im-border);

    .search {
      height: 40px;
      display: flex;
      align-items: center;

      .el-input__inner {
        border: unset;
        border-bottom: var(--im-border);
      }

    }

    .invite-scroll {
      height: 400px;
    }

    .friend-checkbox {
      margin-right: 20px;
    }
  }

  .arrow {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 10px;
    color: var(--im-color-primary);
  }

  .right-box {
    flex: 1;
    border: var(--im-border);

    .select-tip {
      text-align: left;
      height: 40px;
      line-height: 40px;
      text-indent: 6px;
      color: var(--im-text-color-light)
    }
  }
}
</style>
